import React, { useState } from "react";
import "../MobileCustomerHeader/MobileCustomerHeader.css";
import { FaSearch, FaFilter, FaSortAmountDown } from "react-icons/fa";
import MobileCustomerFilterPopup from "../MobileCustomerHeader/MobileCustomerFilterPopup/MobileCustomerFilterPopup";
import MobileSortModal from "../../../Component/MobileSortModal/MobileSortModal";

const MobileCustomerHeader = ({
  search,
  setSearch,
  columnSearch,
  setColumnSearch,
  onRefresh,
  sortColumn,
  sortOrder,
  onSortChange
}) => {

  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);

  const handleRefresh = () => {
    setSearch("");
    setColumnSearch({
      status: "active",
      customerName: "",
      mobile: "",
      coins: "",
      createdBy: "",
      companyName: "",
      lastLoginStartDate: null,
      lastLoginEndDate: null,
      lastTransactionStartDate: null,
      lastTransactionEndDate: null,
      lastLogin: "",
      lastTransaction: "",
      reference: "",
      address: "",
      mapLocation: "",
    });

    if (onRefresh) onRefresh();
  };

  return (
      <>
          <div className="mobile-customer-header-wrapper">
              <div className="mobile-header">
                  <div className="mobile-search-container">
                      <FaSearch className="mobile-search-icon" />

                      <input
                          type="text"
                          placeholder="Search here..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          className="mobile-search-input"
                      />
                  </div>

                  <div
                      onClick={() => setIsSortOpen(true)}
                      className="mobile-sort-icon"
                  >
                      <FaSortAmountDown />
                  </div>

                  <FaFilter
                      className="mobile-filter-icon"
                      onClick={() => setShowFilterPopup(true)}
                  />
              </div>

              <MobileSortModal
                  isOpen={isSortOpen}
                  onClose={() => setIsSortOpen(false)}
                  onApply={(col, order) => {
                      onSortChange(col, order);
                  }}
                  currentColumn={sortColumn}
                  currentOrder={sortOrder}
                  columns={[
                      { label: "Name", value: "customerName" },
                      { label: "Mobile", value: "mobile" },
                  ]}
              />
          </div>

          {showFilterPopup && (
              <MobileCustomerFilterPopup
                  onClose={() => setShowFilterPopup(false)}
                  columnSearch={columnSearch}
                  setColumnSearch={setColumnSearch}
                  handleRefresh={handleRefresh}
              />
          )}
      </>
  );
};

export default MobileCustomerHeader;